export default __webpack_public_path__ + "static/media/11_tag_non-smoking.17592e26.svg";